import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=5fb4930d&"
import script from "./changePwd.vue?vue&type=script&lang=js&"
export * from "./changePwd.vue?vue&type=script&lang=js&"
import style0 from "./changePwd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb4930d')) {
      api.createRecord('5fb4930d', component.options)
    } else {
      api.reload('5fb4930d', component.options)
    }
    module.hot.accept("./changePwd.vue?vue&type=template&id=5fb4930d&", function () {
      api.rerender('5fb4930d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/changePwd.vue"
export default component.exports